import React, { Component } from 'react';
import { WidgetTypes, QuestionTypes } from '../../constants/QuestionTypes';
import { getDT, getForm, getFormWidgets, getFormWidgetQuestionsAnswers, getInfoConfigShared, getIdentifier, saveResponse, getRowColumns, customValidateForm, getQuestionTypes, getFormData, getFormDataElements } from '../../services/formService';
import { getUserProjects } from '../../services/projectService';
import CustomLoader from '../common/Loader';
import { ToastContainer } from 'react-toastify';
import { toaster, Custom_Forms } from '../../config';
import WidgetViewer from './Viewer/WidgetViewer';
import _, { forEach, split } from 'lodash';
import { logActivity, execGenericSP } from "../../services/utilService";
import {getDataSources} from "../../services/dataSourceService";
import queryString from 'query-string';
import {BASE_URL} from "../../auth/authConfig";

class FormViewer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Form_ID: this.props.Form_ID ? this.props.Form_ID : 0,
			Form_Name: '',
			Widgets: [],
			LightMode: this.props.LightMode ? true : false,
			PreviewMode: this.props.PreviewMode ? true : false,
			SurveyMode: this.props.SurveyMode ? this.props.SurveyMode : false,
			PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : queryString.parse(window.location.search).pk ? queryString.parse(window.location.search).pk : '',
			Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
			Responses: [],
			loading: true,
			DataTableWidget: {},
			ParametersList: [],
			FilterParametersList: [],
			selectedInst: queryString.parse(window.location.search).inst_id ? queryString.parse(window.location.search).inst_id : this.props.selectedInst,
			isTab: this.props.isTab ? this.props.isTab : false,
			isPopUp : this.props.isPopUp ? this.props.isPopUp : false,
			isValid : false,
			triggerRender: true,
			clearForm: false,
			defaultRender : false,
			rulesObj : [],
			Form_SecondaryIDValue: this.props.Form_SecondaryIDValue ? this.props.Form_SecondaryIDValue : 0,
			questionSequence: [],
			dataElements: []
		};
		this.handleCancel = this.handleCancel.bind(this)
	}

	async componentDidMount() {
		let Widgets = this.props.Widgets ? this.props.Widgets : [],
			Form_ID = (this.props.history && queryString.parse(this.props.history.location.search).form_id ) ? queryString.parse(this.props.history.location.search).form_id : this.props.Form_ID,
			Project_ID=(this.props.history && queryString.parse(this.props.history.location.search).project_id ) ? queryString.parse(this.props.history.location.search).project_id : this.props.Project_ID;
		
		//Preview Mode
		if (this.state.PreviewMode) {
			let params = queryString.parse(window.location.search)
			Form_ID = params.Form_ID
			Project_ID = params.Project_ID
		}

		if (Form_ID === undefined) {
			const { data: projects } = await getUserProjects();
			const queryParameters = queryString.parse(this.props.location.search)
			this.setState({ projects });
			if (typeof projects === 'string') {
				console.error('No institutions assigned to user')
				this.setState({ error: true });
			}
			else if (!_.isEmpty(queryParameters) && (queryParameters.project_id) && !(queryParameters.form_id) ) {
				const projectSelected = _(projects).find(obj => obj.Project_ID === parseInt((queryParameters.project_id)));
				Form_ID = projectSelected ? projectSelected['MPOG_Link_Form_ID'] : -2
				Project_ID=projectSelected['Project_ID']
			}
			else if (!_.isEmpty(queryParameters) && (queryParameters.form_id)) {
				Form_ID = queryParameters.form_id
				Project_ID=queryParameters.project_id
			}
			else if (projects.length > 0) {
				Form_ID = projects[0]['MPOG_Link_Form_ID']
				Project_ID= projects[0]['Project_ID']
			}
			else {
				window.location.reload();
			}
		}

		if (!this.state.PreviewMode) {
			let { data: form } = await getForm(parseInt(Form_ID));
			form = form[0];
			this.setState({
				Form_BehaviorOnLoad: form.Form_BehaviorOnLoad,
				Form_BehaviorOnSave: this.props.Form_BehaviorOnSave ? this.props.Form_BehaviorOnSave : form.Form_BehaviorOnSave,
				Form_RedirectTo: form.Form_RedirectTo || '',
				Form_CustomValidationSP: form.Form_CustomValidationSP || undefined,
				Form_ClienstSideRules: form.Form_ClienstSideRules === 'None' ? [] : eval(form.Form_ClienstSideRules) || [],
				Form_SecondaryIDName: (form.Form_BehaviorOnLoad == 1 && form.Form_Name) ? (form.Form_Name).replaceAll(' ', '_') : null,
				Form_SaveButton_disable: form.Form_SaveButton_disable || false,
            	Form_CancelButton_disable: form.Form_CancelButton_disable || false,
			});

			this.setState({isValid : this.state.Form_CustomValidationSP === undefined})

			if (this.props.location) {
				this.setState({ Form_Name: form.Form_Name || '' });
				this.setState({ SurveyMode: true });
				this.setState({ PrimaryKey: (this.props.location.state) ? this.props.location.state.PrimaryKey : null });
				this.setState({ Project_ID });
			}

			let PK_Name = (this.props.history) && (this.props.history.location.state) ? this.props.history.location.state.PK_Name 
							: this.props.PK_Name;
			
			let preloadFormData = await getFormData(this.state.PrimaryKey, this.state.Form_ID, this.state.Form_BehaviorOnLoad, this.state.Form_SecondaryIDName, this.state.Form_SecondaryIDValue)
				.then((response) => response.data);
			preloadFormData.length > 0 && this.setState({ preloadFormData });

			const { data } = await getFormWidgets(Form_ID, false);
			Widgets = data;

			const isThereQAWidgets = _(Widgets).some(widget => widget.Widget_Type_ID === WidgetTypes.QA),
				isThereIdentifierWidget = _(Widgets).some(widget => widget.Widget_Type_ID === WidgetTypes.Identifier),
				isThereRow = (Widgets).some(widget => widget.Widget_Type_ID === WidgetTypes.Row);

			if (isThereQAWidgets || isThereIdentifierWidget || isThereRow) {
				this.setState({ SurveyMode: true });
			}
			this.setState({ Form_ID, PK_Name });

			Widgets.forEach(
				function (widget, id) {
					widget['hasCustomClientValidation'] = false;
				}
			)

			//Assign rules to state variable
			let rulesObj = this.state.rulesObj;
			this.state.Form_ClienstSideRules.map((rule, rIdx) => {
				let lines = rule['Rule_Text'].split('\n'), ruleActionQID = ''; 
				lines.forEach((line, lIdx)=>{
					if(line.includes('START')){
						ruleActionQID = line.split('START #')[1]
						rulesObj = [...rulesObj, {['#'+ruleActionQID]:[]}]
						this.setState({rulesObj})
						Widgets.forEach(
							function (widget) {
								parseInt(widget.Widget_ID) === parseInt(ruleActionQID) && (widget['hasCustomClientValidation'] = true);
							}
						)
					}
					else if(line.includes('IF') && lines[lIdx+1]){
						let tmpLine = (line.split('IF ')[1]).replaceAll('AND','&').replaceAll('OR','||')
						let ifActionObj = {
							"condition" : tmpLine,
							"originalCondStatus": tmpLine.split(/\s+/),
							"parseCond": tmpLine.split(/\s+/),
							"Action": lines[lIdx+1],
							//"conditionRes": false
						}
						rulesObj[rIdx]['#'+ruleActionQID].push(ifActionObj)
						this.setState({rulesObj})
					}
					else if(line.includes('END')){
						return;
					}
				})
			})
		}

		//console.log('FV Form_ID: ', Form_ID);

		//Get all Form Data Elements
		try {
			const { data: DE } = await getFormDataElements(Form_ID);
			this.setState({ dataElements: JSON.parse(DE.dataElements) });
			const { data: DS } = await getDataSources(); //Exec DEs and store results
			let DataSources = DS;
			if (this.state.dataElements.length > 0) {
				let dataElements = this.state.dataElements;
				dataElements.forEach(async function (dataEl, idx) {
					// Institution specific calls
					if (dataEl['jsonParameters'] && dataEl['jsonParameters'].indexOf('@Institution_ID') !== -1) {
						let params = JSON.parse(dataEl['jsonParameters']).map(
							(p) => {
								(p['Name'] === '@Institution_ID') && (p['Default_Value'] = localStorage.getItem('Inst_ID'));
								return p;
							}
						);
						dataEl['jsonParameters'] = JSON.stringify(params);
					}
					var getConn = function (DataSource_ID = this.state.DataSource_ID) {
						const source = DataSources.find((source) => {
							return source.DataSource_ID === DataSource_ID;
						});
						return source.Connection_String;
					}
					dataEl['Connection_String'] = getConn(dataEl.DataSource_ID);
					let { data } = await execGenericSP(dataEl);
					dataElements[idx]['spResult'] = data['data'] ? JSON.parse(data['data']) : [];
				}
				);
				this.setState({ dataElements });
			}
		}
		catch (e) {
			console.error('Error getting form data elements');
		}

		//get all shared info config
		try {
			let { data } = await getInfoConfigShared(Form_ID);
			(typeof data === 'object') && this.setState({ infoConfig: data });
			(typeof data === 'string') && console.error('Error getting Info Config');
			//console.log('data', data)
		}
		catch (e) {
			console.error('Error getting Info Config');
		}

		//Get all QA Widgets per Form
		let widgetsQA = await getFormWidgetQuestionsAnswers(Form_ID).then((response) => response.data);
		widgetsQA && this.setState({ widgetsQA });
		let Responses = new Array(
			[...new Set((this.state.widgetsQA).map((item) => {
					return item["Question_ID"];
				}))
			].filter((r) => r !== undefined).length
		).fill().map(() => []);
		this.setState({Responses})
		//required count

		//console.log('dataElements', this.state.dataElements, this.state.infoConfig, Widgets)
		//Query returns COUNT OF widget IDs for each rowtype widget into withinrow cols
		let enableSave=true
		let Question_Number = 0;
		let infoConfig = this.state.infoConfig, DEs = this.state.dataElements;
		Widgets.forEach(
			function (widget) {
				//('widget.hasSharedDataElement', widget.hasSharedDataElement)
				if (widget.Widget_Type_ID != WidgetTypes.Info && widget.Widget_Type_ID != WidgetTypes.DataTable) {
					widget['CliValidation_Action'] = '';
					widget['CliValidation_ActionWidgetID'] = undefined;
					widget['Question_Number'] = Question_Number
					Question_Number += (widget.Widget_Type_ID === WidgetTypes.Row && widget['WithinRow'] !== null) ? parseInt(widget['WithinRow']) : 1;
				}
				if (widget.Widget_Type_ID == WidgetTypes.Tabs) {
					enableSave = false
				}
				//if has shared DEs, attach the results to widgets
				if (widget.hasSharedDataElement > 0) {
					if (widget.Widget_Type_ID === WidgetTypes.Info) {
						let resultSource = infoConfig.filter((infoEL)=>infoEL.Widget_ID === widget.Widget_ID)[0],
							destDE = DEs.filter((deEl)=> deEl.ResultSource_Content === resultSource['ResultSource_Content']);
							widget['hasSharedDataElement'] = destDE || 0;
							widget['resultSource'] = resultSource;
					}
				}
			}
		);

		(this.state.Form_ID == Custom_Forms.addAeSaeEvent && this.state.Form_SecondaryIDValue !== 0) && (enableSave = false)

		//CHECK ITS PURPOSE
		// Widgets = Widgets.filter((w) => !w.WithinRow).map((w) => ({
		// 	...w,
		// 	Skipped: false,
		// }));
		const { history } = this.props 
		this.setState({
			Widgets,
			enableSave,
			defaultRender: true,
			loading: false
		});

		const DataTableWidget = Widgets.find((obj) => obj.Widget_Type_ID === WidgetTypes.DataTable);
		if (DataTableWidget) {
			const { data } = await getDT(DataTableWidget.Widget_ID);
			const ParametersList = JSON.parse(data.Parameters);
			const FilterParametersList = ParametersList.map((obj) => ({ ...obj, Value: obj.Default_Value }));
			this.setState({ ParametersList, FilterParametersList });
		}
	}

	updateQuestionSequence(response) {
		let questionSequence = [...this.state.questionSequence], delIdx = (this.state.questionSequence).indexOf(response['Responses'][0]['Question_ID']);
		(delIdx !== -1) && questionSequence.splice(delIdx, 1);
		questionSequence.push(response['Responses'][0]['Question_ID']);
		this.setState({ questionSequence });
		//console.log('b4 Response', delIdx, response['Responses'][0]['Question_ID'], this.state.questionSequence);
	}

	validateResponse = (idx, Response) => {
		try {
			//parse rules json -> check against all conditions with all responses, replace changed vbls & evaluate expression -> Update widgets to re-render selected
			let Widgets = [...this.state.Widgets]
			let currentQnum = (Response['Responses'] && Response['Responses'][0]) ? Response['Responses'][0]['Question_Number'] : undefined,
				currentWidget = currentQnum !== undefined ? Widgets.filter((widget) => { return parseInt(widget['Question_Number']) === parseInt(currentQnum) })[0] : undefined,
				isValidCurrentWidget = (currentWidget && (currentWidget.Widget_Type_ID == WidgetTypes.Info ||
					currentWidget.Widget_Type_ID == WidgetTypes.Row ||
					(currentWidget.Widget_Type_ID == WidgetTypes.QA && currentWidget.Question_Type_ID == QuestionTypes.Multiple_Choice)));
			isValidCurrentWidget &&
				this.state.rulesObj.forEach((rule, ruleIdx) => {
					//Get current and destination question values
					let conditionArray = rule[Object.keys(rule)],
						actionWidget = Widgets.filter((widget) => { return parseInt(widget['Widget_ID']) === parseInt(Object.keys(rule)[0].replace('#', '')) })[0],
						actionQNum = (actionWidget) ? actionWidget['Question_Number'] : undefined,
						currentQnum = (Response['Responses'] && Response['Responses'][0]) ? Response['Responses'][0]['Question_Number'] : undefined,
						isValidQuestion = actionWidget && (actionWidget.Widget_Type_ID === WidgetTypes.Info || actionWidget.Widget_Type_ID === WidgetTypes.Row) ? true : (currentQnum !== actionQNum);
					//console.log('isValidQuestion:: ', isValidQuestion, currentQnum, actionQNum, actionWidget);
					if (isValidQuestion) {
						let rulesObj = this.state.rulesObj
						conditionArray.forEach((conditionEl, conIdx) => {
							let tmpCondArray = conditionEl.originalCondStatus
							for (let i = 0; i < tmpCondArray.length; i = i + 2) {
								if ((typeof tmpCondArray[i] !== 'boolean')) {
									let isValidRuleWidget = Widgets.filter((widget) => { return (widget['Widget_ID']) === parseInt((tmpCondArray[i].split('=')[0]).replace('#', '')) })[0],
										isValidRuleQnum = isValidRuleWidget ? isValidRuleWidget['Question_Number'] === currentQnum : false;
									//console.log('inside: isValidRuleWidget', isValidRuleWidget)
									Response['Responses'] !== undefined &&
										Response['Responses'][0]['Answer_Text'] &&
										((Response['Responses'][0]['Answer_Text'] !== null) && (Response['Responses'][0]['Answer_Text'].length !== 0)) &&
										(Response['Responses'][0]['Question_Number'] !== (actionQNum)) &&
										isValidRuleQnum && //check the working of this in add mode vs view mode
										(rulesObj = this.state.rulesObj) &&
										(rulesObj[ruleIdx][Object.keys(rule)[0]][conIdx]['parseCond'][i] = (Response['Responses'][0]['Answer_Text'][0]).includes((tmpCondArray[i]).split('=')[1]))
								}
								this.setState({ rulesObj })
							}
							let evalRes = '', evalStr = (this.state.rulesObj[ruleIdx][Object.keys(rule)[0]][conIdx]['parseCond']).join(' ')
							!(evalStr.includes('=')) && (evalRes = eval(evalStr))
							//console.log('evalRes', evalRes, evalStr, conditionArray[conIdx]);
							conditionArray[conIdx].conditionRes = (evalRes === true || evalRes === 1)
							if (evalRes === false || evalRes === 0) {
								let tempWID = ((Widgets.filter((cWidget) => { return (cWidget['Widget_ID']) === actionWidget['Widget_ID'] }))[0]).Widget_ID;
								Widgets.map((widget) => {
									if (tempWID == widget.Widget_ID) {
										widget['CliValidation_Action'] = undefined;
										widget['CliValidation_ActionWidgetID'] = undefined;
									}
								})
							}
							conditionArray[conIdx].originalCondStatus = (conditionEl.condition).split(/\s+/)
						})

						//whichver condition has only true, assign that to
						let tempWID = actionWidget && ((Widgets.filter((cWidget) => { return (cWidget['Widget_ID']) === actionWidget['Widget_ID'] }))[0]).Widget_ID,
							destAction = (this.state.rulesObj[ruleIdx][Object.keys(rule)[0]].filter((ruleEl) => { return (ruleEl.conditionRes === true) }))
						if (destAction.length > 0) {
							Widgets.map((widget) => {
								if (tempWID == widget.Widget_ID) {
									widget['CliValidation_Action'] = destAction[0].Action;
									widget['CliValidation_ActionWidgetID'] = tempWID
								}
							})
						}
					}
				})
			return Widgets;
		}
		catch (error) {
			console.error('Error in validtion of the component: ', error);
			return this.state.Widgets;
		}
	}

	handleResponse = (idx, Response) => {
		//check skip logic	
		if (Response !== undefined && 'Skip' in Response) {
			let Widgets = [...this.state.Widgets];
			Widgets = Widgets.map((w) => {
				let temp = w;
				temp.Skipped = Response.Skip == null ? false : !!Response.Skip.includes(w.Widget_ID);
				return temp;
			});
			this.setState({ Widgets });
		}
		if (Response !== undefined && 'Identifier' in Response) {
			this.setState({ PrimaryKey: Response.Identifier })
		}
		let Responses = this.state.Responses;
		Response !== undefined && Response['Responses'] && !('Identifier' in Response) && (Response.Widget_ID = this.state.widgetsQA.filter((w) =>  w['Question_ID'] === Response['Responses'][0]['Question_ID'])[0]['Widget_ID']);
		Response !== undefined && Response.Responses && Response.Responses.length > 0 && (Responses[idx] = Response) && this.setState({ Responses });

		let Widgets = [...this.state.Widgets];
		Response['Responses'] && this.state.rulesObj && (Widgets=this.validateResponse(idx, Response));
		//console.log('Response: ', idx, Response['Responses'])
		Response['Responses'] && this.updateQuestionSequence(Response);
		this.setState({ Widgets });
	};

	handleSaveResponse = async (source) => {
		let to_save = [], Widgets = this.state.Widgets, questionSequence = this.state.questionSequence;

		(this.state.Responses).forEach(function (res) {
			let response = res;
			//if (!this.state.Widgets[i].Skipped) {
			//Map Question sequence
			//console.log(questionSequence.indexOf(response.Responses[0]['Question_ID']), response.Responses[0]['Question_ID']);
			response.Responses && response.Responses[0] && 
				(response['Responses'][0]['Question_Seq'] = questionSequence.indexOf(response.Responses[0]['Question_ID']) >= 0 ? (questionSequence.indexOf(response.Responses[0]['Question_ID'])+1) : 0);
			if (response.Response_Required && response.Responses.length === 0) {
				to_save = [];
				return;
			} else if (response.Responses && response.Responses.length > 0) {
				//clear up hidden fields from save response
				let w = Widgets.filter((w) => { return (w.Widget_ID === response.Widget_ID);})[0] || undefined;
				if (!(w && w['CliValidation_ActionWidgetID'] && (w['CliValidation_Action']).includes('HIDE'))) {
					to_save = [...to_save, ...response.Responses];
				}
			}
			//}
		}
		);

		//console.log('questionSequence: ', questionSequence);
		//Inner tab forms
		//(this.state.Widgets.some(el => el['Widget_Type_ID'] === WidgetTypes.Identifier) && !(to_save.some(el => el['Identifier_ID']))) || 
		if ((this.state.PrimaryKey!==null && this.state.PK_Name)) {
			// let idResp = {
			// 	'Identifier_ID': this.state.PrimaryKey,
			// 	'Response': this.state.PrimaryKey,
			// 	'Identifier_Name': (this.state.PK_Name) ? this.state.PK_Name : null
			// }
			to_save = [...to_save];
		}
		to_save = to_save.filter((resp) => { return (resp.Answer_Text != null || resp.Answer_ID != null);});
	
		//Validation Start

		let validationError = 'Server Side Validation Failed'
		if (this.state.Form_CustomValidationSP) {
			// call the validation api and set isValid
			try {
				const { data: validationResponse } = await customValidateForm(this.state.Form_ID, this.state.PrimaryKey, to_save, this.state.Form_CustomValidationSP, this.state.Form_SecondaryIDValue);
				!validationResponse.includes('Error') && this.setState({ isValid: true })
				validationResponse.includes('Error') && (validationError = validationResponse)
			}
			catch (e) {
				console.error('Error while performing Server Validation: ', e)
				this.setState({ isValid: false })
			}
		}
		(!this.state.isValid) && toaster('warning', validationError);

		let isValidRequiredFieldsCount = true;
		(this.state.widgetsQA).forEach((item) => {
			let w = this.state.Widgets.filter((w) => w.Widget_ID === item['Widget_ID'])[0] || undefined;
			if (item['Response_Required'] === true && !(w !== undefined && w['CliValidation_ActionWidgetID'] && (w['CliValidation_Action']).includes('HIDE')))
			{
				if ((to_save.filter((r) => r['Question_ID'] === item['Question_ID'])).length === 0) {
					isValidRequiredFieldsCount = false;
					return;
				}
			}
		});
		(!isValidRequiredFieldsCount) && toaster('warning', 'Please make sure to enter data for all required fields!');
	

		//Validation End
		//console.log('TO_SAVE: ', to_save);

		let btnSource = typeof source !== 'object' && source.includes('Custom') ? 'Custom' : 'Save';
		const { data } = await saveResponse(this.state.Project_ID, this.state.Form_ID, this.state.PrimaryKey, this.state.Form_SecondaryIDValue, to_save, btnSource);
		if (typeof data !== 'number' && data.includes('Error')) {
			toaster('error', data);
			logActivity('/formBuilder', 'FORMVIEWER_SAVE_FAILED');
		} else {
			toaster('success', 'Form Saved');
			logActivity('/formBuilder', 'FORMVIEWER_SAVE_SUCCESS');
			//Form Save Action
			(this.state.Form_ID === Custom_Forms.addAeSaeEvent) && (window.location.reload())
			if (parseInt(this.state.Form_BehaviorOnSave) === 1 && !this.state.isTab) { //Redirect Form
				window.location = BASE_URL + `form?form_id=${this.state.Form_RedirectTo}&project_id=${this.state.Project_ID}&pk=${this.state.PrimaryKey}&inst_id=${this.state.selectedInst}`
			}
			else if (parseInt(this.state.Form_BehaviorOnSave) === 2) { //Clear Form
				this.setState({ clearForm: true, triggerRender: !this.state.triggerRender })
			}
			typeof data === 'number' && this.setState({ Form_SecondaryIDValue: data });
		}
	};

	handleCancel() {
		(this.state.isTab || this.state.isPopUp) ?
			((this.state.rulesObj.length > 0 || this.state.Form_ID === Custom_Forms.addAeSaeEvent) ? window.location.reload() : this.setState({ triggerRender: !this.state.triggerRender }))
			: (window.location = BASE_URL + 'projectViewer?project_id=' + this.state.Project_ID);
	}

	handleFilterParameters = (FilterParametersList) => {
		this.setState({ FilterParametersList });
	};

	render() {
		const { Form_ID, Form_BehaviorOnLoad, Form_BehaviorOnSave, Form_SecondaryIDName, Form_SecondaryIDValue, SurveyMode, LightMode, PrimaryKey, PK_Name, Project_ID, FilterParametersList, Widgets, enableSave, isTab, preloadFormData, dataElements, infoConfig } = this.state;
		if (this.state.loading) {
			return <CustomLoader loading={this.state.loading} />;
		}

		if (Form_ID < 0) {
			return (
				<div className='container'>
					<div className='alert alert-danger' role='alert'>
						{Form_ID === -2 && 'No form exists.'}
						{Form_ID === -1 && 'Not valid entry to access form.'}
					</div>
				</div>
			);
		}
		return (
			<React.Fragment>
				{this.state.SurveyMode && (
					<React.Fragment>
						{
							PrimaryKey && !isTab &&
							<header className='page-header page-header-dark bg-gradient-primary-to-secondary'>
								<div className='container'>
									<div className='page-header-content pt-4'>
										<div className='row align-items-center justify-content-between'>
											<div className='col-auto mt-4'>
												<h1 className='page-header-title'>
													<div className='page-header-icon'>
														<i data-feather='file'></i>
													</div>
													{this.state.Form_Name}
												</h1>
											</div>
											<div className='col-12 col-xl-auto mt-4'>Primary Key(Test field): {this.state.PrimaryKey}</div>
										</div>
									</div>
								</div>
							</header>
						}
						{
							!PrimaryKey && <div className=' pb-5'></div>
						}
						<div className='container mt-n4'>
							<div className='card'>
								<div className='card-body'>
									<div className='sbp-preview'>
										<div className='sbp-preview-content'>
											{Widgets.map((widget, idx) => (
												<div hidden={widget.Skipped} key={'V' + widget.Widget_ID}>
													{
													((this.state.defaultRender) || (this.state.clearForm) || (widget.Widget_Type_ID == WidgetTypes.QA && widget.CliValidation_Action !== '')) &&
													<WidgetViewer
														Widget={widget}
														Form_ID={Form_ID}
														Form_BehaviorOnLoad={Form_BehaviorOnLoad}
														Form_BehaviorOnSave={Form_BehaviorOnSave}
														Question_Number={widget.Question_Number}
														CliValidation_Action={widget.CliValidation_Action}
														CliValidation_ActionWidgetID={widget.CliValidation_ActionWidgetID}
														OnUpdate={this.handleResponse}
														SurveyMode={SurveyMode}
														PrimaryKey={PrimaryKey}
														PK_Name={PK_Name}
														Project_ID={Project_ID}
														LightMode={LightMode}
														FilterParametersList={FilterParametersList}
														onSubmitFilterParameters={this.handleFilterParameters}
														key={this.state.triggerRender}
														selectedInstitution={this.state.selectedInst}
														Responses={this.state.Responses}
														Form_SecondaryIDName={Form_SecondaryIDName}
														Form_SecondaryIDValue={Form_SecondaryIDValue}
														Custom_Save={this.handleSaveResponse}
														widgetsQA={this.state.widgetsQA}
														preloadFormData={preloadFormData}
														dataElements={dataElements}
														infoConfig={infoConfig}
														sharedDataElement={widget.hasSharedDataElement}
														resultSource={widget.resultSource}
													/>
												}
												</div>
											))}
										</div>
									</div>
									{enableSave && (
										<div className='d-flex justify-content-center mt-1'>
											{!(this.state.Form_SaveButton_disable === 'True') && (<button className='btn btn-primary rounded-0' onClick={this.handleSaveResponse}>
												Save
											</button>)}
											{!(this.state.Form_CancelButton_disable === 'True') && (<button className='btn btn btn-outline-danger rounded-0 ml-2' onClick={this.handleCancel}>
												Cancel
											</button>
											)}
										</div>
									)}
									{Form_ID === Custom_Forms.addAeSaeEvent && !enableSave && (
										<div className='d-flex justify-content-center mt-1'>
											<button className='btn btn btn-outline-danger rounded-0 ml-2' onClick={this.handleCancel}>
												Cancel
											</button>
										</div>
									)}
								</div>
							</div>
						</div>
					</React.Fragment>
				)}

				{!this.state.SurveyMode && (
					<React.Fragment>
						{this.state.Widgets.map((widget, idx) => (
							<div hidden={widget.Skipped} key={'viewerWidget' + widget.Widget_ID}>
								<WidgetViewer
									Widget={widget}
									Form_ID={Form_ID}
									Form_BehaviorOnLoad={Form_BehaviorOnLoad}
									Form_BehaviorOnSave={Form_BehaviorOnSave}
									Question_Number={(widget.Widget_Type_ID !== WidgetTypes.Info || widget.Widget_Type_ID !== WidgetTypes.Button || widget.Widget_Type_ID !== WidgetTypes.DisplayEditInfo ) ? widget.Question_Number : ''}
									CliValidation_Action={widget.CliValidation_Action}
									CliValidation_ActionWidgetID={widget.CliValidation_ActionWidgetID}
									OnUpdate={this.handleResponse}
									SurveyMode={SurveyMode}
									PrimaryKey={PrimaryKey}
									PK_Name={PK_Name}
									Project_ID={Project_ID}
									LightMode={LightMode}
									FilterParametersList={FilterParametersList}
									onSubmitFilterParameters={this.handleFilterParameters}
									key={this.state.triggerRender}
									selectedInstitution={this.state.selectedInst}
									Responses={this.props.Responses}
									Form_SecondaryIDName={Form_SecondaryIDName}
									Form_SecondaryIDValue={Form_SecondaryIDValue}
									Custom_Save={this.handleSaveResponse}
									widgetsQA={this.state.widgetsQA}
									preloadFormData={preloadFormData}
									dataElements={dataElements}
									infoConfig={infoConfig}
									sharedDataElement={widget.hasSharedDataElement}
									resultSource={widget.resultSource}
								/>
							</div>
						))}
					</React.Fragment>
				)}
				<ToastContainer/>
			</React.Fragment>
		);
	}
}

export default FormViewer;